import React, { useContext } from "react";
import { BaseContext } from "./base-context";
import { useProfileImage } from "./hooks/useProfileImage";

export const Badge: React.FC = () => {
    const profileImage = useProfileImage();
    const { setIsSidebarShown } = useContext(BaseContext);

    return (
        <button 
            onClick={() => setIsSidebarShown(true)}
            className="opacity-30 hover:opacity-100 transition-opacity duration-200"
        >
            {profileImage}
        </button>
    );
};
